import { useUsersQuery } from './useUsersQuery';

import { createMutationHook } from '~/shared/providers/api';

export interface CoreUserEnableMutationParams {
  id: string;
}

export const useCoreUserEnableMutation = createMutationHook(
  'settings.teamPermissions.userEnable',
  (params: CoreUserEnableMutationParams) => ({
    coreUserEnable: {
      __args: {
        id: params.id,
      },
    },
  }),
  {
    invalidateQueries: [useUsersQuery],
  },
);
